"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const recompose_1 = require("recompose");
const reselect_1 = require("reselect");
const react_redux_1 = require("react-redux");
const selectors_1 = require("@zedoc/selectors");
const QuestionnaireContext_1 = require("./QuestionnaireContext");
const defaultCreateMapStateToProps = (selectQuestionnaire) => (0, reselect_1.createStructuredSelector)({
    questionnaire: selectQuestionnaire,
});
const withDynamicQuestionnaire = (createMapStateToProps = defaultCreateMapStateToProps) => (0, recompose_1.compose)((0, QuestionnaireContext_1.withContext)(), (0, react_redux_1.connect)(createMapStateToProps((0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (context) => context.select.dynamicQuestionnaire()))));
exports.default = withDynamicQuestionnaire;
//# sourceMappingURL=withDynamicQuestionnaire.js.map